(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["workmind_blocco_filtri_collection"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function() {
        //elemento che contiene i filtri scritti nel metafield
        const collectionFilterHide = document.querySelector('#collection-filter-hide');
        // Seleziona il contenitore del filtro
        const filterContainer = document.querySelectorAll('.accordion-details'); // Sostituisci con il selettore corretto


        // Nascondi il filtro se è presente nel metafield
        for(let container of filterContainer){
          for(let filter of collectionFilterHide.value.split(',')){
            
                //non devono importare nel confronto lettere maiuscole e minuscole
                if(container.querySelector('.accordion-details__summary .h4').textContent.toLowerCase() == filter.toLowerCase()){
                    container.style.display = 'none';
                }
            }
        }


    });


  } catch(e) { console.error(e); }
})();
})();
